/**
 * AcceptanceCriteriaList (v1.8.0) — pass/fail chips for the 8 ТЗ
 * acceptance criteria. Read-only.
 */

import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import type { DesignAssetAcceptanceCriterion } from '@segmently/schema-models/content-plan';

export interface AcceptanceCriteriaListProps {
  criteria: DesignAssetAcceptanceCriterion[];
}

export const AcceptanceCriteriaList: React.FC<AcceptanceCriteriaListProps> = ({ criteria }) => {
  return (
    <Stack spacing={1} data-testid="design-brief-acceptance">
      <Typography variant="subtitle2">Acceptance</Typography>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {criteria.map((c) => (
          <Chip
            key={c.id}
            size="small"
            color={c.pass === true ? 'success' : c.pass === false ? 'error' : 'default'}
            label={c.label ?? c.id}
            title={c.reason ?? undefined}
            data-testid={`design-brief-acceptance-criterion-${c.id}`}
          />
        ))}
      </Stack>
    </Stack>
  );
};
